import React from "react";
import styled from "styled-components";
import { styledMedia } from "../../../components/mediaquery/breakpoints";
import CategoryHead from "../../../components/categoryhead";
import PageTitle from "../../../utils/page-title";
import * as PropTypes from "prop-types";

const Styled = {
  OuterContainer: styled.div`
    margin-top: 43px;

    ${styledMedia.small`
      margin-top: 20px;
    `}
  `,
  HeadContainer: styled.div`
    margin-left: 18px;
  `,
  Grid: styled.ul`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 32px;
    // margin-bottom 0 due to context pre-padding
    margin: 20px 38px 0;

    ${styledMedia.medium`
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
    `}

    ${styledMedia.small`
      grid-template-columns: repeat(2, 1fr);
    `}

    ${styledMedia.tiny`
      grid-template-columns: repeat(1, 1fr);
    `}
  `
};

/**
 * V2 book grid using CSS Grid
 *
 * COLUMN widths and spacing are pre-defined, but card heights depend on the cards.
 * Mixed card types with varying layout rules can work together fine as long as
 * there is a stretchable section (e.g. flex: 1)
 *
 * Initial use is for expired books, so I have not gotten into lazy rendering since
 * it should be low numbers. Also our current a11y patterns suggest not doing that sort
 * of thing on scroll anymore, but via a "Load More"
 *
 * @see FlexibleBookCard
 */
class FlexibleBookGrid extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    let { children, pageTitle, headerText, onHeaderClick } = this.props;
    return (
      <Styled.OuterContainer>
        <PageTitle title={pageTitle} />
        <Styled.HeadContainer>
          <CategoryHead caretLeft label={headerText} onClick={onHeaderClick} />
        </Styled.HeadContainer>
        <Styled.Grid>{children}</Styled.Grid>
      </Styled.OuterContainer>
    );
  }
}

export default FlexibleBookGrid;
